import { useMediaQuery } from "react-responsive"

const useResponsive = () => {
  const isDesktop = useMediaQuery({
    query: "(min-width: 1200px)",
  })
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1199px)" })
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" })

  return { isDesktop, isTabletOrMobile, isMobile }
}

export default useResponsive
